module.exports = __webpack_public_path__ + "static/media/Kageyama.2ebde12b.png";